import alt from '../../alt';
import si from 'si';

class MyAddressesActions {
	constructor() {

	}

	getAddresses() {
		si.getAddresses().then(this.getAddressesSuccess, this.registerErrors);
		return true;
	}

	getAddressesSuccess(addresses) {
		if(addresses && addresses.shipping) {
			this.toggleShippingSameAsHome(false);
		}
		return addresses;
	}

	toggleEditHomeAddress(isOpen) {
		return isOpen;
	}

	toggleEditShippingAddress(isOpen) {
		if (isOpen) {
			this.toggleShippingSameAsHome(false);
		}
		return isOpen;
	}

	toggleCreateAdditionalAddress(isOpen) {
		return isOpen;
	}

	toggleEditAdditionalAddress(key, isOpen) {
		var diff = {};
		diff[key] = isOpen;
		return diff;
	}

	toggleShippingSameAsHome(isSame) {
		if (isSame) {
			this.saveShippingAddress(null);
		}
		return isSame;
	}

  editHomeAddress() {
    this.toggleEditHomeAddress(true);
  }

	saveHomeAddress(address) {
		si.updateHomeAddress(address).then(this.getAddresses, this.registerErrors);
		this.toggleEditHomeAddress(false);
		return true;
	}

	saveHomeAddressSuccess(response) {
		return response;
	}

	saveShippingAddress(address) {
		si.updateShippingAddress(address).then(this.getAddresses, this.registerErrors);
		this.toggleEditShippingAddress(false);
		return true;
	}

	saveShippingAddressSuccess(response) {
		return response;
	}

  editShippingAddress() {
  	this.toggleEditShippingAddress(true);
  	return true;
  }

	addAdditionalAddress() {
		this.toggleCreateAdditionalAddress(true);
		return true;
	}

	createAdditionalAddress(address) {
		si.createAdditionalAddress(address).then(this.getAddresses, this.registerErrors);
		return true;
	}

	deleteAdditionalAddress(addressCode, confirmationMessage) {
		var response = confirm(confirmationMessage);
		if (response == true) {
				si.deleteAdditionalAddress(addressCode).then(this.getAddresses, this.registerErrors);
		}
	}

	updateAdditionalAddress(address) {
		si.updateAdditionalAddress(address).then(this.getAddresses, this.registerErrors);
		this.toggleEditAdditionalAddress();
		return true;
	}

	finishAddAdditionalAddress() {
		this.toggleCreateAdditionalAddress(false);
		return true;
	}

	registerErrors(error) {
		console.log(error);
	}

}

export default alt.createActions(MyAddressesActions);



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/MyAddresses/MyAddressesActions.js